<template>
   <el-tabs type="border-card">
    <el-tab-pane label="文章标签列表">
      <div style="margin-top:16px;">
        <el-table
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            show-overflow-tooltip
            label="类别名称">
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      aritcleForm: {
        title: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getAritcleList()
  },
  methods: {
    getAritcleList: function() {
      this.optionItem = this.common.extend(this.aritcleForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/articleType/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getAritcleList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getAritcleList()
    }
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/aritcle/aritcleTypeList.vue